<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="编辑"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customerPayMethod"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="客户名称">
          <el-input v-model="customerPayMethod.customerName" disabled placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="付款方式">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="customerPayMethod.payMannerType" placeholder="请输入" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.selectPayManner.open()"/>
            </el-input>
            <pay-manner-select ref="selectPayManner" @select="selectPayManner"/>
          </div>
        </el-form-item>
        <el-form-item label="有效日期">
          <el-radio-group v-model="customerPayMethod.isForever">
            <el-checkbox v-model="checked" @change="change">永久有效</el-checkbox>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="customerPayMethod.isForever === 0" label="开始日期" prop="beignDate">
          <el-date-picker
              v-model="customerPayMethod.beignDate"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"/>
        </el-form-item>
        <el-form-item v-if="customerPayMethod.isForever === 0" label="结束日期" prop="endDate">
          <el-date-picker
              v-model="customerPayMethod.endDate"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmitAfter">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import PayMannerSelect from "@/views/information/PayManner/PayMannerSelect";

  export default {
    name:"CustomerPayMethodEdit",
    components: {PayMannerSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        checked: true,
        parentNameList: [],
        customerPayMethod: {
          pmrid: "",
          pmid: "",
          beignDate: "",
          customerID: "",
          customerName: "",
          endDate: "",
          ids: "",
          isDef: "",
          isDeleted: "",
          isForever: "",
          payMannerId: "",
          payMannerType: "",
        },
        ruleValidate: {
          beignDate: {required: true, message: "不能为空",trigger: "blur"},
          endDate: {required: true, message: "不能为空",trigger: "blur"},
        },
        pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() > Date.now();
          // },
          shortcuts: [{
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          }, {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          }, {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          }],
        },
      };
    },
    methods: {
      open(id) {
        this.customerPayMethod.pmrid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      selectPayManner(row) {
        console.log(row);
        let payNodeTypeList = [];
        // let pmidList = [];
        if(row.length>0) {
          for(let item of row) {
            payNodeTypeList.push(item.payNodeType);
            //pmidList.push(item.pmid);
          }
          // this.customerPayMethod.pmid = pmidList
          this.customerPayMethod.payMannerType = JSON.parse(JSON.stringify(payNodeTypeList)).toString();
        }else {
          this.customerPayMethod.pmid = row.pmid;
          this.customerPayMethod.payMannerType = row.payNodeType;
        }
      },
      change() {
        console.log(this.checked);
        if(this.checked === false) {
          this.customerPayMethod.isForever = 0;
        }else {
          this.customerPayMethod.isForever = 1;
        }
      },
      getData() {
        this.$http
          .get("basic", `payMannerRegisters/${this.customerPayMethod.pmrid}`)
          .then(resp => {
            this.customerPayMethod = resp;
            if(this.customerPayMethod.isForever === 0) {
              this.checked = false;
            }else {
              this.checked = true;
            }
          });
      },
      handleSubmitAfter() {
        if (this.customerPayMethod.isForever === 0) {
          let beignDate = new Date(this.customerPayMethod.beignDate);
          let endDate = new Date(this.customerPayMethod.endDate);
          if(beignDate.getTime() > endDate.getTime()) {
            this.$message.error("选择时间不正确，请重新选择");
          }else {
            this.handleSubmit();
          }
        }else {
          this.handleSubmit();
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "payMannerRegisters", this.customerPayMethod)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
